import './ApplicationNumber.css';

export const ApplicationNumber = ({details}) => {
    return <span className='applicationNumber'>{details.application_number}</span>;
}